if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            // Aura 2026-10-14: the thumbnail strip is server-rendered filtered by color and never re-synced on
            // variant change, so a variant's media can be in the viewer but not in the strip. Dawn threw here
            // (null.parentElement), aborting the whole variant update: price, gallery and Add to cart all froze
            // and the buy buttons stayed disabled. Skip the thumbnail instead of throwing.
            activeThumbnail &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        activeThumbnail && this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Aura 2026-10-16: Retro Finder hero video (see product-media-gallery.liquid). Autoplay muted loop; nothing plays for
// reduced-motion or data-saver visitors (they get the poster). iOS and Chrome only honour `autoplay` for a muted
// element, and nodes that arrive through Dawn's section re-render lose the muted flag, so set it and play explicitly.
window.cxcHeroVideoKick = function () {
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  document.querySelectorAll('video[data-hero-video]').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    if (reduce || saveData) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
  });
};
document.addEventListener('DOMContentLoaded', () => window.cxcHeroVideoKick());
window.addEventListener('pageshow', () => window.cxcHeroVideoKick());

/* Retro Finder PDP (phones): keep the "‹ 1/11 ›" counter a fixed 12px inside the bottom of the ACTIVE slide's
   media frame, whatever the screen width or the slide's aspect ratio. CSS (clawsxcode.css) keeps a fixed bottom offset
   as the no-JS fallback; this sets an inline top that overrides it. */
(function () {
  var INSET = 12;
  var queued = false;
  function place() {
    queued = false;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || !document.querySelector('variant-selects[data-product-handle="the-retro-finder-keyboard-for-mac"]')) return;
    var sc = gallery.querySelector('slider-component');
    var buttons = sc && sc.querySelector('.slider-buttons');
    if (!buttons || !buttons.offsetParent) return;
    var vw = window.innerWidth;
    var items = sc.querySelectorAll('.slider .product__media-item');
    var active = null;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].offsetParent) continue;
      var r = items[i].getBoundingClientRect();
      var mid = r.left + r.width / 2;
      if (mid >= 0 && mid <= vw) { active = items[i]; break; }
    }
    if (!active) return;
    var frame = active.querySelector('.product__media') || active.querySelector('img, video') || active;
    var bottom = frame.getBoundingClientRect().bottom - sc.getBoundingClientRect().top;
    var top = bottom - INSET - buttons.getBoundingClientRect().height;
    if (top > 0) {
      buttons.style.top = Math.round(top) + 'px';
      buttons.style.bottom = 'auto';
    }
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(place);
  }
  document.addEventListener('DOMContentLoaded', function () {
    queue();
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var slider = gallery.querySelector('.slider');
    if (slider) slider.addEventListener('scroll', queue, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(queue).observe(gallery);
    new MutationObserver(queue).observe(gallery, { childList: true, subtree: true });
    gallery.addEventListener('load', queue, true);
  });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  window.addEventListener('pageshow', queue);
})();
